<template>
  <GraduateApply :applyType="1" />
</template>

<script>
import GraduateApply from './GraduateApply.vue';

export default {
  name: 'GraduateSingleApply',
  components: {
    GraduateApply,
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/PersonalCenters/components/GraduateSingleApply.vue